export enum Timeout {
    DEFAULT = 20_000
}
